// sticky-navbar.ts

/**
 * Throttle function to limit scroll event fire rate
 */
function throttle(fn: () => void, wait: number): () => void {
	let lastCall = 0;
	return function () {
		const now = new Date().getTime();
		if (now - lastCall >= wait) {
		lastCall = now;
		fn();
		}
	};
}

/**
 * Sticky hide/show nav on scroll direction
 */
function initStickyNavbar(navId: string = '#branding', offset = 200): void {
	const nav = document.querySelectorAll<HTMLElement>(`${navId}`)[0];
	if (!nav) return;

	let lastScrollY = window.scrollY;

	const handleScroll = throttle(() => {
		const currentScroll = window.scrollY;

		if (currentScroll > lastScrollY && currentScroll > offset) {
			nav.classList.remove('revealing');
			nav.classList.add('hidden');
		} else {
			nav.classList.remove('hidden');
			nav.classList.add('revealing');
		}

		lastScrollY = currentScroll;
	}, 100); // Throttle every 100ms

	window.addEventListener('scroll', handleScroll);
}

export { initStickyNavbar };  